<template>
  <v-card>
    <v-card-text>
      <v-container>
        <v-row>

          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-autocomplete
              v-model="pModel"
              :items="pItems"
              label="Profession"
              prepend-icon="search"
              return-object
              clearable
              autocomplete="new-password"
              :loading="isLoading"
              :search-input.sync="pSearch"
              dense
              placeholder="Profession name"
              no-data-text="start typing to search"
             
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="4">
            <v-autocomplete
              v-model="ctSelect"
              :items="ctItems"
              label="Company type"
              prepend-icon="search"
              return-object
              clearable
              autocomplete="new-password"
              :loading="isLoading"
              dense
              placeholder="Company type name"
              no-data-text="start typing to search"
              :search-input.sync="ctSearch"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-autocomplete
              v-model="cdSelect"
              :items="cdItems"
              label="Department name"
              prepend-icon="search"
              return-object
              clearable 
              autocomplete="new-password"
              :loading="isLoading"
              dense
              placeholder="Department name"
              no-data-text="start typing to search"
              :search-input.sync="cdSearch"
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-checkbox 
              label="Freelance"
              v-model = "freelance"
              dense
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-autocomplete
              v-model="cSelect"
              :items="cItems"
              label="Company name"
              prepend-icon="search"
              :search-input.sync="cSearch"
              return-object
              clearable
              autocomplete="new-password"
              :loading="isLoading && !cSelect && cSearch"
              dense
              placeholder="Company name"
              no-data-text="start typing to search"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-autocomplete
              v-model="rSelect"
              :items="rItems"
              label="Relationship to film"
              prepend-icon="search"
              :search-input.sync="rSearch"
              return-object
              clearable
              autocomplete="new-password"
              :loading="isLoading && !rSelect && rSearch"
              dense
              placeholder="Relationship name"
              no-data-text="start typing to search"
            >        
            </v-autocomplete>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-checkbox 
              label="Cameo"
              v-model = "cameo"
              dense
            ></v-checkbox>
          </v-col>

          <v-col cols="12" sm="6" md="6" lg="4" xl="4">
            <v-checkbox 
              label="Hidden"
              v-model = "hidden"
              dense
            ></v-checkbox>
          </v-col>
        </v-row>

      </v-container>
    </v-card-text>
    <v-card-actions>
        <v-btn color="primary"
          :disabled="saveDisabled"
          @click="$emit('save',newFilmToPerson)"
        >Save</v-btn>
        <v-btn color="secondary" 
          @click="$emit('cancel')"
        >Cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>

import { Controls, FilmToPersonRelationshipTypes, SearcherResultProf, SearcherResultCom} from '@/gql'
import { getStateElDefaults, settings } from '@/js/store'
const { keyNames, filterNames } = settings.elastic.autoComplete.filmToPerson
/*
* identifying the professionID is complex
* as a professionID is a combination of name/companytype/companydepartment/freelance
* all of which can be independently specified
* the idea is that a record is savable when there is only 1 potential ID left
* TODO - the big problem here is that we're firing off all 3 searches that
* are actually dependent on the results of the other in parallel
* need to find a way of not relying on the computed vars changing, but doing it in a more controlled way.
*/
export default {
  props: {
    skeleton: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      Controls: null,
      pSearch: null,
      ctSearch: null,
      cdSearch: null,
      FilmToPersonRelationshipTypes: null,
      SearcherResultProf: null,
      SearcherResultCom: null,
      cdModel: this.makeDefaultData({
        nameProp:'companyDepartmentName', 
        key:'companyDepartmentName',
        idField:'companyDepartmentID'
      }),
      ctModel: this.makeDefaultData({
        nameProp:'companyTypeName',
        key:'companyTypeName',
        idField: 'companyTypeID'
      }),

      pModel: this.makeDefaultData({
        nameProp:'professionName',
        key:'name',
        idField: 'professionID'
      }),

      cModel: this.makeDefaultData({
        nameProp:'companyName',
        key:'companyName',
        idField: 'companyID'
      }),
      rModel: this.makeDefaultData({
        nameProp:'relationshipTypeName',
        idField:'relationshipTypeID'
      }),
      rSearch: this.rModel && this.rModel.text,
      cSearch: this.cModel && this.cModel.text,
      fModel: this.skeleton.freelance,
      cameo: this.skeleton.cameo,
      hidden: this.skeleton.hidden,
      oldFilmToPerson: {  
        professionID: this.skeleton.professionID,
        companyID: this.skeleton.companyID,
        cameo: this.skeleton.cameo,
        filmID: this.skeleton.filmID,
        id: this.skeleton.id,
        personID: this.skeleton.personID,
        relationshipTypeID: this.skeleton.relationshipTypeID,
        hidden: this.skeleton.hidden
      }
    }
  },

  methods: {


    // the default data is derived from either a call sheet
    // or an existing filmto person record
    // or even derived from the 'usual' person/profession/company
    // and normalized so it can be used to get an autocomplete kickstart
    makeDefaultData ({sourceProp = 'skeleton', nameProp, key, idField}) {
      const source = this[sourceProp][nameProp]
      const id = this[sourceProp][idField]
      const result =  source ? {
        text: source,
        value: source,
        ids: id ? [id] : null,
        keyName: key ? this.getKeyName(key) : null
      } : null

      return result
    },

    getAggs (queryData) {
     
      const a = queryData 
        ? {
          ...queryData,
          aggs: queryData.aggregations ? JSON.parse(queryData.aggregations) : null
        } : null
        return a
    },

    pushSearchKey (vs,key,v) {
      v = v || []

      if (vs) {
        const values = vs.split(/[\s,.-/:;]+/)
        values.forEach(value=>{
          v.push({value, key})
        })
      }

      return v
    },
    getAggBuckets (t, keyName) {
      const ab = t && t.buckets.map(f=>({
        keyName,
        text: f.key,
        value: f.key,
        bucket: f,
        ids: f.ids.buckets.map(g=>g.key)
      })) || null
     
      return ab
    },
    getComBuckets () {
      const keyName = 'company-company-auto-name'
      const prop = 'autoName'
      const t = this.aggsCom && this.aggsCom[prop]
      return this.getAggBuckets(t, keyName)
    },
    getBuckets (prop) {
      const t = this.aggs && this.aggs[prop]
      const keyName = this.getKeyName(prop)
      if(!keyName) {
        console.error('couldnt find prop',prop,' in keynames')
      }
      return this.getAggBuckets(t, keyName)
    },
    getKeyName (prop) {
      return keyNames.find(f => prop === f.name)
    },
    getElInclude(name, filters) {
      // get the include definition for the given key
      const {key} = this.getKeyName(name)
      if (!key) {
        console.error('failed to get keyname for', name)
      }
      const ob = this.profEl.DefaultIncludes.find(f=> f.key === key) 
      if(!ob) {
        console.log('couldnt find key', key,'in', this.profEl)
      }
      // make a new instance so we can play with it
      const ot = JSON.parse(JSON.stringify(ob))

      // the apollo typename screws up whn in the params, so get rid of it
      delete ot.__typename
      
      // for this use case , we dont want any default filters to be inherited
      ot.filters = null
      if (filters && filters.length) {
        const ofilters = JSON.parse(JSON.stringify(filters))
        ot.filters = Array.isArray(ofilters) ? ofilters : [ofilters]
      } 
      return ot
    },

    // the model contains the ids that match that model, so they can added to the filter
    getIdFilter (model) {

      if (!model) return null

      // now find the filterdefinition
      const {keyName} = model
      const {filterOn} = keyName
      const filterName = filterNames.find(f=> f.name === filterOn)

      if(!filterName) {
        console.error('count find filteron', filterOn)
        return null
      }
      // sometime the filter is a value derived from the current selection or seach sync
      // otherwise its a list of potential ids derived from other searches
      const value = filterName.useModel ? ([model.value]) : model.ids
      if(!value || !value.length) return null

      return {
        key:filterName.key,
        values: [{
          key: filterName.valueKey,
          value
        }]
      }
    }
  },

  computed: {
    inProgress () {
      return this.Controls && this.Controls.saveInProgress
    },
    makeSearchVars () {
      // this adds field names to the search queryfrom each of models
      // eg - turns director into 'profession-profession-name:director'

      const v = [] 
      // this is tricky - pSearch is the sync field (character by character), model is either the last selected or an initial value
      // so the query is either the new typed sync field, or if null , the selected model 

      this.pushSearchKey ( this.pSearch || (this.pModel && this.pModel.value) , this.getKeyName('name').key,v)
      this.pushSearchKey ( this.ctSearch || (this.ctModel && this.ctModel.value) ,this.getKeyName('companyTypeName').key,v)
      this.pushSearchKey ( this.cdSearch || (this.cdModel && this.cdModel.value) ,this.getKeyName('companyDepartmentName').key,v)
      const q = v.length ? v.map(f=>`${f.key}:${f.value}`).join(' ') : null
      return q
    },
    makeQueryVars () {
      
      const q =  {
        ...this.basicVars,
        itemType: "profession",
        value: this.makeSearchVars,
        elIncludes: this.makeFilters
      } 

      return q
    },
    queryVars () {
      return this.makeQueryVars
    },
    companyTypeName () {
      return this.ctSelect && this.ctSelect.text 
    },

    companyTypeID () {
      return this.ctSelect && this.ctSelect.ids && this.ctSelect.ids[0]
    },

    // the autocomplete vuetify component sets a cleared component to undefined rather than null
    // so this workaround..
    pSelect: {
      get() {
        return this.pModel;
      },
      set(val) {
        this.pModel = val || null;
      }
    },

    cSelect: {
      get() {
        return this.cModel;
      },
      set(val) {
        this.cModel = val || null;
      }
    }, 

    rSelect: {
      get() {
        return this.rModel;
      },
      set(val) {
        this.rModel = val || null;
      }
    },

    ctSelect: {
      get() {
        return this.ctModel;
      },
      set(val) {
        this.ctModel = val || null;
      }
    },

    cdSelect: {
      get() {
        return this.cdModel;
      },
      set(val) {
        this.cdModel = val || null;
      }
    },

    freelance: {
      get() {
        return this.fModel;
      },
      set(val) {
        this.fModel = val;
      }
    },
    // the structure of filmtoperson row that will be mutated back on save
    newFilmToPerson () {
      return {
        ...this.oldFilmToPerson,
        professionID: this.finalProfessionID,
        companyID: this.finalCompanyID,
        cameo: this.cameo,
        relationshipTypeID: this.finalRelationshipTypeID,
        hidden: this.hidden
      }
    },


    // finds the default includes for this kind of query
    profEl () {

      if(!this.elVars) return null
      const profEl = this.elVars.Defaults.find(f=>f.itemType === 'profession')
      if(!profEl){
        console.log('couldnt find profession in', this.elVars)
        return null
      }
      return {
        ...profEl,
        __typename: undefined
      }
    },

    isLoading () {
      // can be used to detect if data is being fetched
      return this.$apollo.loading
    },

    // get the default keys for this kind of elastic search
    elVars () {
      return getStateElDefaults()
    },

    ctItems () {
      return this.getBuckets('companyTypeName') || []
    },

    pItems () {
      return this.getBuckets('name') || []
    },

    cdItems () {
      return this.getBuckets('companyDepartmentName') || []
    },

    rItems () {
      return (this.FilmToPersonRelationshipTypes || []).map(t=> ({
        ...t,
        value: t.RelationshipType && t.RelationshipType.id,
        text: (t.RelationshipType && t.RelationshipType.RelationshipTypeLocalized && t.RelationshipType.RelationshipTypeLocalized.name) || 'name missing'
      }))
    },

    cItems () {
      return this.getComBuckets() || []
    },

    basicVars () {
      return {
        noCache: true,
        searcherType: "ELASTIC",
        limit: settings.elastic.autoComplete.limit,
        offset: 0,
        elIncludes: null,
        hideMatches:this.totalRows !==1,
        hideAggs: false
      }
    },
    // node query -t company -q=low  -y companyauto
    comQueryVars () {
      // generates the variables for a search based ont he laready completed models
      const q =  this.makeComSearchVars ? {
        ...this.basicVars,
        itemType: "company",
        queryType: "companyauto",
        value: this.makeComSearchVars,
        hideMatches: this.comTotalRows !==1
      } : null

      return q;
    },
    whichFilters() {
      // the 'active search is where the sync value is not equal to the model value
      return [
        this.pModel  && this.pModel.value === this.pSearch && this.pModel, 
        this.ctModel && this.ctModel.value === this.ctSearch && this.ctModel, 
        this.cdModel && this.cdModel.value === this.cdSearch && this.cdModel
      ].filter(f=>f)
    },
    makeFilters () {
      // consolidates the filters based on each of the models
      
      const f = this.whichFilters
      
      const filters = f.reduce((p,c)=>{
          const m = c ? this.getIdFilter(c) : null
          if (m) {
            p.push (m)
          }
          return p
        },[...this.freelanceFilter])

      const made =  [
        this.getElInclude('name',filters),
        this.getElInclude('companyTypeName', filters),
        this.getElInclude('companyDepartmentName', filters)
      ];

      return made
    },
    makeComSearchVars () {
      return  this.cSearch || (this.cModel && this.cModel.value)
    },

    // these are the base include filters for each search
    // and the filters are added based on the other selections
    freelanceFilter () {
      
      return [{
          key: 'profession-profession-freelance',
          values: [{
            key: 'profession-freelance',
            value: [Boolean(this.freelance)]
          }]
        }]
    },
    saveDisabled () {
      return !this.finalProfessionID || this.inProgress
    },
    finalRelationshipTypeID () {
      return this.rSelect && this.rSelect.ids && this.rSelect.ids[0]
    },
    finalCompanyTypeID () {
      return this.ctSelect && this.ctSelect.ids && this.ctSelect.ids[0]
    },
    finalCompanyDepartmentID () {
      return this.cdSelect && this.cdSelect.ids && this.cdSelect.ids[0]
    },
    finalProfessionID () {
      return this.totalRows === 1 && 
        this.queryData.Searchers && 
        this.queryData.Searchers[0] && 
        this.queryData.Searchers[0].itemID
    },
    finalCompanyID () {
      return this.cSelect && this.cSelect.ids && this.cSelect.ids[0]
    },
    totalRows () {
      return this.queryData && this.queryData.totalRows
    },
    comTotalRows () {
      return this.SearcherResultCom && this.SearcherResultCom.totalRows
    },
    queryData () {
      const q =  this.getAggs(this.SearcherResultProf)
      return q
    },
    queryDataCom () {
      return this.getAggs(this.SearcherResultCom)
    },
    aggs () {
      return this.queryData && this.queryData.aggs
    },
    aggsCom () {
      return this.queryDataCom && this.queryDataCom.aggs
    }
   
  },

  apollo: {
    Controls: {
      query: Controls
    },
    FilmToPersonRelationshipTypes: {
      query: FilmToPersonRelationshipTypes
    },
    SearcherResultProf: {
      query: SearcherResultProf,
      skip () {
        const skip = !this.queryVars
        return skip
      },
      variables () {
        return this.queryVars
      }
    },
    SearcherResultCom: {
      query: SearcherResultCom,
      skip () {
        return !this.comQueryVars
      },
      variables () {
        return this.comQueryVars
      }
    }
  }
}
</script>
